var map = {
	"./feature1.png": 856,
	"./feature1@2x.png": 480,
	"./feature2.png": 857,
	"./feature2@2x.png": 624,
	"./feature3.png": 858,
	"./feature3@2x.png": 625,
	"./feature@2x.png": 626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 623;